import cookie from 'js-cookie'
import { getCurrentUser } from '../queries/user/accountUser';

export const handleLogin = (token: string) => {
    cookie.set('token', token);
}

export const handleLogout = () => {
    cookie.remove('token')
}

export const handleIsLoginNow = () => {
    return new Promise((resolve, reject) => {
        if (cookie.get("token")) {
            getCurrentUser(cookie.get("token") ?? "")
                .then(response => resolve(response))
                .catch(error => reject(error))
        } else {
            resolve({
                isLoginNow: false
            })
        }
    })
    
}

// export const redirectUser = (ctx, location) => {
//     if(ctx.req){
//         ctx.res.writeHead(302, { Location: location });
//         ctx.res.end()
//     } else {
//         Router.push(location)
//     }
// }



export const anonymus = () => {
    return {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": 'application/json'
        }
    }
}

export const payload = (token: string) => {
    return {
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: `Token ${token}`,
            "Content-Type": 'application/json'
        }
    }
}

export const payloadMultipart = (token: string) => {
    return {
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: `Token ${token}`,
            "Content-Type": 'multipart/form-data'
        }
    }
}

export const smsapi = (token: string) => {
    return {
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
            "Content-Type": 'application/json'
        }
    } 
}

// export const dynamicSort = (property: Array<String>) => {
//     var sortOrder = 1
//     if(property[0] === "-") {
//         sortOrder = -1
//         property = property.substr(1)
//     }
//     return function (a,b) {
//         var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
//         return result * sortOrder
//     }
// }